import { createSelector } from 'reselect';

export const getById = ({ role }) => role.byId;
export const getIds = ({ role }) => role.list.allIds;
export const getRole = (state, id) => getById(state)[id];
export const getRoleList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));

export const getRoleByRoleType = (state, roleType) => getRoleList(state).find(role => role.RoleType === roleType);
